<template>
  <div>
    <myHeader/>
    <banner title="报告查询"/>
    <div class="report-main">
      <!-- 暂无报告 -->
      <div v-if="reportList.length <= 0" class="report-zero">
        <el-image class="none-image" :src="noneImage"/>
        <div class="none-tip">暂无报告</div>
      </div>
      <div v-loading="loading" v-else class="report-list">
        <el-table ref="singleTable" class="report-table" :data="reportList" style="width: 1080px" border
                  :header-cell-style="rowClass">
          <el-table-column type="index" label="序号" align="center" width="50">
            <template slot="header">
              <span class="table-col-name">序号</span>
            </template>
          </el-table-column>
          <el-table-column property="declareDate" label="报告时间">
            <template slot="header">
              <span class="table-col-name">报告时间</span>
            </template>
          </el-table-column>
          <el-table-column property="val" label="信用分值">
            <template slot="header">
              <span class="table-col-name">信用分值</span>
            </template>
          </el-table-column>
          <el-table-column property="status" label="报告状态">
            <template slot="header">
              <span class="table-col-name">报告状态</span>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" style="color: rgba(153, 153, 153, 1);">未生成</span>
              <span v-if="scope.row.status === 2" style="color: rgba(255, 141, 26, 1);">生成中</span>
              <span v-if="scope.row.status === 3" style="color: rgba(13, 158, 71, 1);">已生成</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="257">
            <template slot="header">
              <span class="table-col-name">操作</span>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" @click="doPay()" class="one-btn">缴费</span>
              <span v-if="scope.row.status === 3" @click="doLook(scope.row)" class="one-btn">查看报告</span>
              <span v-if="scope.row.status === 3" @click="doDownload(scope.row)" class="one-btn">报告下载</span>
              <span @click="doDel(scope.row)" class="one-btn">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <myFooter bgc="black"/>

    <customer-service :dialogVisible="dialogVisible" @reset="dialogVisible = false"/>
  </div>
</template>

<script>
import {delReport, reportList} from "@/api/common";

export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      noneImage: require('../../assets/none.png'),
      reportList: [],
      dialogVisible: false
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      reportList().then(res => {
        let list = res.data
        if (list && list.length > 0) {
          list.forEach(one => {
            // 时间格式处理
            one.declareDate = one.declareDate.substr(0, 10)
            this.reportList.push(one)
          })
          this.loading = false;
        }
      })
    },

    doPay() {
      this.dialogVisible = true
    },
    closePayDialog() {
      this.dialogVisible = false
    },
    doLook(row) {
      this.$router.push({name: 'reportDetail', params: row})
    },
    doDownload(row) {
      // reportDownload(row.reportId).then()
      window.location.href = domain.api + '/credit/report/export?id=' + row.reportId
    },
    doDel(row) {
      this.$confirm('确定删除自测报告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        delReport({id: row.id}).then(res => {
          this.$message.success("删除成功")
          this.reportList = []
          this.init()
          this.loading = false;
        })
      }).catch(() => {});
    },
    // 设置表格头部样式 背景色
    rowClass({rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return {background: '#fafbfc'}
      }
    },

  }

}
</script>

<style scoped>
.report-main {
  width: 100%;
  min-height: 458px;
  padding-bottom: 38px;
}

.report-zero {
  display: flex;
  flex-direction: column;
  justify-content: center;

}

.none-image {
  width: 160px;
  height: 160px;
  margin: 57px auto 10px;
}

.none-tip {
  text-align: center;
}

.report-list {
  margin-top: 38px;
}

.report-table {
  margin: 0 auto;
}

.one-btn {
  letter-spacing: 0px;
  line-height: 24px;
  text-decoration-line: underline;
  color: rgba(63, 140, 255, 1) !important;
  margin-right: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/report/index.vue